import type { DataEnvironment } from "../api/runtimeConfig";

const LOCAL_SITE_BASE_URL = "http://localhost:4321";
const PRODUCTION_SITE_BASE_URL = "https://greensparks.live";

const normalizeBaseUrl = (value: string) => value.replace(/\/$/, "");

const getDefaultSiteEnvironment = (): DataEnvironment => {
  const hostname = window.location.hostname;
  return hostname === "localhost" || hostname === "127.0.0.1" ? "dev" : "prod";
};

export const getSiteBaseUrl = (dataEnvironment: DataEnvironment = getDefaultSiteEnvironment()) => {
  if (dataEnvironment === "dev" && process.env.REACT_APP_DEV_SITE_BASE_URL) {
    return normalizeBaseUrl(process.env.REACT_APP_DEV_SITE_BASE_URL);
  }

  if (dataEnvironment === "prod" && process.env.REACT_APP_PROD_SITE_BASE_URL) {
    return normalizeBaseUrl(process.env.REACT_APP_PROD_SITE_BASE_URL);
  }

  if (process.env.REACT_APP_SITE_BASE_URL) {
    return normalizeBaseUrl(process.env.REACT_APP_SITE_BASE_URL);
  }

  return dataEnvironment === "dev" ? LOCAL_SITE_BASE_URL : PRODUCTION_SITE_BASE_URL;
};

export const getSiteHref = (path: string, dataEnvironment?: DataEnvironment) =>
  `${getSiteBaseUrl(dataEnvironment)}${path}`;
